import qs from 'qs';
import { getThemeConf } from '@/utils/theme';
import { defaultExtuinInfo } from '@/utils/extuinInfo';
import wpaBridge from '@/utils/wpaBridge';
import { addCssStyle } from '@/utils/tools';
import fetchCommonInfo from '@/utils/commonConfig';
import fetchCompanyInfo from '@/utils/companyInfo';

import MixinBubble from '@/components-business/MixinBubble';
import MixinLogin from '@/components-business/MixinLogin';
import MessageBubble from '@/components-business/MessageBubble';
import MsgAutoComplete from '@/components-business/MsgAutoComplete';
import QuickOrderCard from '@/components-business/EcCard/QuickOrderCard.vue';
import GoodsList from '@/components-business/EcGoodsOrder/GoodsList.vue';
import OrderList from '@/components-business/EcGoodsOrder/OrderList.vue';

import { addQQ, qqInvite } from '@/utils/qq';
import { CHECK_IF_WEBIM_V3, SEND_BUSINESS_CARD } from '@/utils/api';
import { removeUrlQuery } from '@/utils/urlTools';
import { myLocalStorage } from '@/utils/myLocalStorage';
import globalWin from '@/utils/globalWin';
import { isPrivate } from '@/utils/env';
import { createClickId } from '@/utils/createClickId';
import { getInitXmlMsg } from '@/utils/initXmlMsg';
import AUTH_TYPE from '@/utils/authType';

import { QidianLongMap } from '@/i18n';

export default {
  mixins: [MixinBubble, MixinLogin],
  components: {
    MessageBubble,
    MsgAutoComplete,
    QuickOrderCard,
    GoodsList,
    OrderList,
  },
  data() {
    return {
      isPrivate,
      aioReady: false,
      // 配置样式，主要是设置IM的主题色。通过css变量实现。
      customStyle: '',
      // PC模式背景图片
      pcBgImage: '',
      // H5模式背景图片
      h5BgImage: '',

      // sdk事件状态
      sessionStart: false,

      // 接待配置信息
      wpaDetail: {
        // wpaId, // wpa的id
        // kfuin, // 主号
        // reception_type, // 自定义进线的类型：1单人，2分组
        // reception_id, // 自定义进线类型对应的值，单人是为员工id，分组时为分组id
        // 缺省clickid。外部传入时将被覆盖
        clickid: createClickId(),
      },

      // 鉴权数据
      authConf: {
        // 鉴权离线
        authType: '',
        // 鉴权数据，格式： a=1&b=2&c=3。 如果是url鉴权，则将url中的所有参数直接获取到即可。
        authData: '',
        // 第三方鉴权跳转地址。
        authRedirectUrl: '',
      },

      // 各种功能按钮开关
      showInfo: {
        isManualClose: 0, // 是否显示 手动结束会话
        isShowFace: 0, // 是否显示表情
        isAllowSendShortVoice: 0, // 是否显示语音输入
        isAllowSendImage: 0, // 是否显示图片发送
        isAllowSendFile: 0, // 是否显示文件发送
        isSurvey: 0, // 是否显示满意度
        isShowAudo: 0, // 是否显示 机器人转人工
        isAllowExitQueue: 0, // 是否显示 主动退出排队
        isUseWebSidebar: 1, // 是否显示侧边栏【客服免费版】
        isShowSafetyTips: 0, // 是否显示安全提示【客服免费版】
        isShowQidianSign: 0, // 是否显侧边栏示标志区
        isShowGoods: 0, // 商品按钮显示
        isShowOrder: 0, // 订单按钮显示
      },

      linkInfo: {
        externalType: 1, // 右侧显示：1-企业形象；2-员工形象。
        openName: 1, // 左侧显示：1-企业信息，2员工信息，员工信息获取失败时用企业信息兜底。
      },

      guidanceInfo: {
        // ...
        // // 引流二维码
        // guidanceData: {
        //   name: '测试',
        //   key: '478440079',
        //   type: '企业群',
        //   level: 0,
        //   currentNumber: 1,
        //   qrUrl: 'http://p.qpic.cn/qidian_pic/0/20220928263377b4e7f15815a8bf591e32acb447/0',
        //   logo: 'http://p.qlogo.cn/gh/478440079/478440079/100',
        // },
      },

      // 企业信息
      companyInfo: {},

      // webim被wpa嵌入iframe时的状态
      iframeIMStatus: 'show',

      // 未读消息数
      notReadNumber: 0,
      onlineNotReadNum: 0,

      // 接待信息
      reception: {
        // inWaitPool: 是否在未接入池/排队
        // isRobot: 是否机器人
        // robotId: 如果是机器人，机器人的分组id
        // extuin: 人工接待时的工号或分组号
        // receptionType: 接待类型，无用。
      },

      // 输入框的内容
      inputContent: '',

      // message list
      messageList: [],
      // webim样式配置
      styleConfig: {
      },

      // 当前浏览器通知总数
      msgNotifyCount: 0,
      // 当前通知
      notification: null,
      // 当前人工接待信息
      employeeInfo: {},

      // 商品列表显示
      goodsListShow: false,
      // 订单列表显示
      orderListShow: false,
      // 电商配置
      ecQuickMenu: {
        goodsTab: [], // 商品tab配置
        orderTab: [], // 订单tab配置
      },
      // 是否展示右上角翻译开关
      isShowLangIcon: false,
      // 是否进线之后立即发送名片
      isSendBizCardInstant: false,
      // 是否开启机器人联想词功能
      canRobotAutoComplete: false,

      // 已读回执开关
      readStatusSwitch: false,
    };
  },
  computed: {
    /**
     * show top qq icon
     */
    showQQ() {
      return !this.isPrivate && this.aioReady && this.isNormalReception && this.guidanceInfo.guidanceQQ;
    },
    unReadSum() {
      return this.notReadNumber + this.onlineNotReadNum;
    },
    /**
     * 是否在wpa-iframe中
     */
    inIframe() {
      return wpaBridge.inIframe();
    },

    /**
     * 是否移动端
     * @returns
     */
    isMobile() {
      return !this.$platform.pc;
    },
    /**
     * 是否是正常接待状态（人工或机器人接待）
     * @returns
     */
    isNormalReception() {
      if (this.reception.extuin || this.reception.robotId) {
        return true;
      }
      return false;
    },

    // 当前接待工号。仅人工(单人/分组)接待有效。机器人接待均返回 0 。
    currExtuin() {
      const { extuin } = this.reception;
      return extuin || 0;
    },

    /*
    AIO内置功能按钮actionType列表：
    ['sendFace', 'sendImageMessage', 'sendFileMessage', 'activeFeedback', 'robotTransfer', 'closeSession', 'exitQueue']
    对于内置功能按钮，请传入 actionType, isShow, enable 3个参数。enable在PC有disabled效果。 H5中【isShow && enable】联合判断是否显示。
    对于自定义按钮，请传入 name, icon, isShow, enable 4个固定参数以及一个 自定义参数，如type，来处理点击后的逻辑。
    */
    toolButtonsCommon() {
      const { weappBtnConf } = this;
      let weappAudioBtnConf = null;
      let weappVideoBtnConf = null;
      if (weappBtnConf && weappBtnConf.path) {
        weappAudioBtnConf = {
          ...weappBtnConf,
          path: `${weappBtnConf.path}&mediaType=2`,
        };
        weappVideoBtnConf = {
          ...weappBtnConf,
          path: `${weappBtnConf.path}&mediaType=1`,
        };
      }
      const btns = [
        {
          actionType: 'sendFace',
          isShow: !!this.showInfo.isShowFace,
          enable: true,
        },
        {
          actionType: 'sendImageMessage',
          isShow: !!this.showInfo.isAllowSendImage,
          enable: true,
          // 授权提示。图片和文件单独配置。如果不需要授权提示，请传入null
          // authorizeTip: {
          //   title: '是否允许访问您设备上的相册和文件？',
          //   explain: '允许后可上传图片及文件，提高沟通效率',
          // },
          authorizeTip: this.showInfo.isContentAuthorize ? this.guidanceInfo.authorizeTip : null,
        },
        {
          actionType: 'sendFileMessage',
          isShow: !!this.showInfo.isAllowSendFile,
          enable: true,
          // 授权提示。图片和文件单独配置。如果不需要授权提示，请传入null
          authorizeTip: this.showInfo.isContentAuthorize ? this.guidanceInfo.authorizeTip : null,
        },
        {
          type: 'audio',
          icon: this.isMobile ? require('./assets/audio.svg') : require('./assets/audio_line.svg'),
          name: this.$t('common_audio_text'),
          isShow: !!this.showInfo.isShowVoiceCall && this.currExtuin,
          enable: this.employeeInfo.webimAv && this.currExtuin,
          // H5跳转音视频小程序配置
          // 当无法启用时，应移除此值或设置为null
          weappBtnConf: weappAudioBtnConf,
        },
        {
          type: 'video',
          icon: this.isMobile ? require('./assets/video.svg') : require('./assets/video_line.svg'),
          name: this.$t('common_video_text'),
          isShow: !!this.showInfo.isShowVideoCall && this.currExtuin,
          enable: this.employeeInfo.webimAv && this.currExtuin,
          // H5跳转跳转音视频客服独立版小程序配置。
          // 当无法启用时，应移除此值或设置为null
          weappBtnConf: weappVideoBtnConf,
        },
        {
          actionType: 'activeFeedback',
          isShow: !!this.showInfo.isSurvey,
          enable: this.isNormalReception,
        },
        {
          actionType: 'robotTransfer',
          isShow: !!this.showInfo.isShowAudo,
          enable: !!this.reception.robotId,
        },
        // 注意下方的逻辑：结束会话和退出排队逻辑互斥，且2个图标一致，因此当不处于命中状态时，则不显示这2个按钮
        {
          actionType: 'closeSession',
          isShow: !!this.showInfo.isManualClose && this.isNormalReception,
          enable: this.isNormalReception,
        },
        {
          actionType: 'exitQueue',
          isShow: !!this.showInfo.isAllowExitQueue && this.reception.inWaitPool,
          enable: this.reception.inWaitPool,
        },
        {
          actionType: 'sendBusinessCard',
          type: 'sendBusinessCard',
          icon: require('./assets/business-card.svg'),
          name: this.$t('send_business_card_btn'),
          isShow: !!this.showInfo.isShowBusinessCard,
          enable: true,
        },

        // 自定义按钮示例
        // {
        //   type: 'goodsList',
        //   icon: require('./assets/video.svg'),
        //   name: this.$t('Test'),
        //   isShow: true,
        //   enable: true,
        // },
        // 商品
        {
          type: 'goodsListBtn',
          icon: require('./assets/goods.svg'),
          name: this.$t('ec_goods_text'),
          isShow: !!this.showInfo.isShowGoods,
          enable: this.isNormalReception,
        },
        // 订单
        {
          type: 'orderListBtn',
          icon: require('./assets/order.svg'),
          name: this.$t('ec_order_text'),
          isShow: !!this.showInfo.isShowOrder,
          enable: this.isNormalReception,
        },
        {
          type: 'capture',
          icon: require('./assets/scissors.svg'),
          name: this.$t('common_screenshot_text'),
          isShow: !!this.showInfo.isAllowCapture,
          enable: true,
        },
        // // todo xuedongwang
        // {
        //   type: 'test',
        //   icon: require('./assets/video.svg'),
        //   name: this.$t('Test'),
        //   isShow: true,
        //   enable: true,
        // },
      ];
      return btns;
    },
    // PC功能按钮配置
    toolButtonsForPC() {
      const btns = this.toolButtonsCommon;
      return btns;
    },

    // H5功能按钮配置。注意，和PC不一样的点：1.仅H5有语音发送；2.仅PC可以调整表情发送按钮位置
    toolButtonsForH5() {
      const btns = this.toolButtonsCommon;
      // 追加语音输入功能
      btns.unshift({
        actionType: 'sendVoice',
        isShow: !!this.showInfo.isAllowSendShortVoice,
        enable: true,
      });
      return btns;
    },

    // 机器人自动完成功能配置
    configToAutoMsg() {
      const { kfuin } = this.wpaDetail;

      return {
        kfuin,
        enable: !!this.reception.robotId && this.canRobotAutoComplete,
        robotId: this.reception.robotId,
      };
    },
  },
  watch: {
    currExtuin(newVal) {
      if (newVal) {
        this.fetchEmployeeInfo(newVal);
      }
    },
    reception(newVal) {
      // 机器人接待时拉取机器人相关配置
      if (newVal && newVal.isRobot && newVal.robotId) {
        this.fetchRobotConfig(newVal);
      }
    },
  },

  mounted() {
    this.init();
    this.requireNotifyPermission();
    this.twinkleHanlder = this.twinkleDocTitle();

    // 外部debug，自动化测试
    if (location.href.indexOf('debug=1') > -1) {
      window.uiDebuger = this;
    }
  },

  methods: {
    async init() {
      if (wpaBridge.inIframe()) {
        // 如果是在iframe中，则IM不自动启动，而是等待wpa的postMessage进行回调
        // 从receive事件中获取kfuin，wpaId等信息。
        // 然后根据receive的不同act做不同响应
        console.log('[start-inIframe]');
        // 如果是被嵌入iframe中，那么这个状态默认值为close
        this.iframeIMStatus = 'close';
        // 监听父页面发送的message事件
        wpaBridge.bindListener(this);

        // 绑定顶部栏拖动逻辑，仅PC有效。
        // 完整title
        const motTit = document.querySelector('.drag-title-inIframe');
        // mini-bar
        const motTItMini = document.querySelector('drag-title-inIframe-mini');
        motTit && wpaBridge.bindDragEvent(motTit);
        motTItMini && wpaBridge.bindDragEvent(motTItMini);
        // 新增iframe中的sso判断
        // 此处可能有问题，因为此时可能没有实例化
        // if (this.wpaDetail.auth) {
        //   this.authConf.authtype = this.wpaDetail.auth;
        // }
      } else {
        // 先mock假数据
        this.getWpaConfigFromUrl();
        // this.wpaDetail = { kfuin: 2852199039, wpaId: 999 };
        // 监测是不是webim要回滚到老webim去
        if (this.authConf?.authType === 'commonAuth') {
          // 如果是通用鉴权，就要同步执行，先获得redirectUrl。
          this.authConf.authRedirectUrl = await this.checkIfWebimV3(1);
        } else {
          // 否则，直接检查新老版本
          this.checkIfWebimV3();
        }

        // 启动IM
        this.startIM();
      }
    },
    /**
     * 唤起qq
     */
    handleLunchQQ() {
      // msg
      // let roleValue = '';
      // // 1单人，2分组
      // if (this.reception.reception_type === 1) {
      //   roleValue = 0;
      // }
      // if (this.reception.reception_type === 2) {
      //   roleValue = 1;
      // }
      const params = {
        kfuin: this.wpaDetail.kfuin,
        visitorId: this.$refs.aio?.to?.user_id,
        fid: this.wpaDetail.fid || this.wpaDetail.wpaKey,
        ftype: this.isMobile ? 1 : 0,
        roleValue: this.wpaDetail.roleValue,
        roleData: this.wpaDetail.roleData || '',
        isInIframe: this.inIframe,
        isMobile: this.isMobile,
        isCorpUin: this.guidanceInfo.guidanceQQType === 2 ? 0 : 1, // 1：企业主号接待，2：员工接待
      };
      qqInvite(params);
    },
    handleAddQQ(msg) {
      const params = {
        kfext: this.wpaDetail.roleData,
        kfaccount: msg.msgBody.qq,
        kfuin: this.wpaDetail.kfuin,
        visitorId: this.$refs.aio?.to?.user_id,
        isMobile: this.isMobile,
        ftype: this.isMobile ? 1 : 0,
      };
      addQQ(params);
    },
    setLang() {
      if (this.wpaDetail.qidian_lang) {
        this.$setLocale(QidianLongMap[this.wpaDetail.qidian_lang]);
      } else {
        this.$setLocale('zh');
      }
    },
    // 从url中获取wpa的配置
    getWpaConfigFromUrl() {
      const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      if (!params.kfuin || !(params.wpaId || params.fid)) {
        this.$Alert('缺少必要的接入参数：[kfuin, wpaId/fid]');
        return;
      }
      if (!params.wpaId) { // 兼容链接型wpa参数
        params.wpaId = params.fid;
      }
      globalWin.translate = {
        translateSwitch: +params.translateSwitch || 0,
        translateAuto: true, // 自动翻译开关，默认开启
      };

      if (+params.translateSwitch) {
        this.isShowLangIcon = true;
      }
      if (+params.isSendBizCardInstant) {
        this.isSendBizCardInstant = true;
      }
      if (params.auth) {
        this.authConf.authType = params.auth;
        // 链接型，直接将url中所有参数传入进线鉴权判断
        this.authConf.authData = location.search.replace(/^\?/, '');
        // 鉴权数据已缓存，从url中移除。后续使用authData值
        // 根据广交会的代码发现还是有中间页的跳转逻辑的，所以此处的逻辑作废，还是走中间页去处理这块的逻辑和之前的逻辑保持一致
        // if (params.auth.indexOf('LingLong') !== -1 && params.access_token) {
        //   this.authConf.authData += `&code=${params.access_token}`;
        // };
        this.removeAuthDataFromUrl();
      }
      this.wpaDetail = Object.assign({}, this.wpaDetail, params);
    },

    // 从url中移除掉鉴权所用的数据
    removeAuthDataFromUrl() {
      let currentUrl = window.location.href;
      currentUrl = removeUrlQuery(currentUrl, 'code');
      currentUrl = removeUrlQuery(currentUrl, 'response_type');
      currentUrl = removeUrlQuery(currentUrl, 'session_state');
      currentUrl = removeUrlQuery(currentUrl, 'scope');
      currentUrl = removeUrlQuery(currentUrl, 'nonce');

      // 1.1 缓存msgInfo信息
      this.storeGJHMsgInfo();
      // 1.2 并从url中删除
      currentUrl = removeUrlQuery(currentUrl, 'msgInfo');
      currentUrl = removeUrlQuery(currentUrl, 'isSendBizCardInstant');

      // 更新url
      window.history?.replaceState({}, '', currentUrl);
      console.log('[auth]', 'Auth data has been removed from url');
    },

    // 存储或读取广交会 msgInfo
    storeGJHMsgInfo(isRead) {
      // TODO: onSessionStart()=>{ const msgInfo = this.storeGJHMsgInfo(true); // 上行广交会信息 }
      // ------ 读取缓存的msgInfo ------
      if (isRead) {
        const msgInfo = myLocalStorage.getItem('QIDIAN_MESSAGE_INFO');
        myLocalStorage.removeItem('QIDIAN_MESSAGE_INFO');
        return msgInfo;
      }

      // ------ 写入 ------
      // 从url中获取msginfo并存储起来。
      // 为什么？——msginfo是广交会传递的商品卡片信息，有可能数据比较大。
      // 如果在跳转的过程中还带着它的话，可能会导致url太长而出现问题。因此要把这个参数单独存储一下。
      const urlParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      const { msginfo } = urlParams;
      if (msginfo) {
        myLocalStorage.setItem('QIDIAN_MESSAGE_INFO', msginfo);
      }
    },

    // 设置主题色，背景图
    getCustomStyle(newThmeData = null) {
      const { customStyle, setting } = getThemeConf(this.wpaDetail, newThmeData);
      this.customStyle = customStyle;
      this.pcBgImage = setting.pcBgImage;
      this.h5BgImage = setting.h5BgImage;
      addCssStyle(setting.bgColor);
    },

    // 启动IM会话
    async startIM() {
      this.setLang();
      const ua = navigator.userAgent;
      // wx_qy为企微ssc鉴权。仅在企微环境可运行。但是，企微有一个插件，可以直接在微信环境运行，因此微信环境也允许执行。
      if (this.authConf.authType === 'wx_qy' && ua.indexOf('wxwork') === -1 && !this.$platform.Weixin) {
        this.$Alert('请使用企微内置浏览器进行网页咨询').then(() => {
          window.opener = null;
          window.open('', '_self', '');
          window.close();
        });
        return;
      }

      // 从缓存中读取theme配置，先设置上。
      this.getCustomStyle();
      // 获取style config
      this.fetchConfig();
      // 新增wpa时iframe中的sso判断
      if (wpaBridge.inIframe() && this.wpaDetail.auth) {
        this.authConf.authType = this.wpaDetail.auth;
        this.authConf.authData = `auth=${this.wpaDetail.auth}`;
      }
      // 鉴权、登录、进线
      this.checkAccountAndLongin();
    },

    /**
     * 鉴权、登录、进线
     */
    async checkAccountAndLongin(isRetry) {
      if (isRetry) {
        // TODO 看看是否后续要处理这个流程。
        console.error('[checkAccountAndLongin][isRetry]');
      }

      this?.$refs?.aio?.createIncomingTip();
      // 调用AIO内的方法，进行接入。
      const loginConfig = await this.createLoginConfig();
      if (loginConfig) { // 容错处理
      // 将数据存入，UI侧需要用到。
      // 注意：和鉴权相关的逻辑， 必须等进线之后在处理。
      // 不能看到 有  aid 了就进行， 因为此时 aid 未必是 对的。必须要等进线之后才能确定aid+d2是对的
      // 因为上面的 createLoginConfig 会先返回缓存的账号信息去进线，此时未必是正确的。
      // 如果进行失败，是需要重新走checkAccountAndLongin这个方法的。
        this.$set(this.wpaDetail, 'visitorid', loginConfig.aid);
        this.$set(this.wpaDetail, 'token', loginConfig.d2);
        globalWin.auth = loginConfig;
        globalWin.wpaDetail = this.wpaDetail;
        this.$refs.aio.startIM(loginConfig);
      }
    },

    /**
     * 监听aio组件内变量，并赋值到当前组件
     * @param {string} dataName 要监听的变量名称
     * @param {string} curDataName 当前组件内对应的变量名
     */
    watchAioData(dataName, curDataName) {
      if (!curDataName) {
        // eslint-disable-next-line no-param-reassign
        curDataName = dataName;
      }

      this.$watch(
        () => this?.$refs?.aio[dataName] || 0,
        (val) => {
          this[curDataName] = val;
        },
      );
    },


    // 点击工具栏按钮
    clickToolBtn(item) {
      console.log('a', item);
      // todo
      // if (item.type === 'test') {
      // //   const data = {
      // //     "type":1,
      // //     "title":{
      // //         "text":"添加QQ联系人"
      // //     },
      // //     "picture":{
      // //         "action":"addFriend",
      // //         "actionData":"938197342",
      // //         "cover":"https://p.qpic.cn/qidian_pic/2852199203/20230104ac8d193276ae868e2bdeb635e39c30e9/0"
      // //     },
      // //     "detailText":{
      // //         "mainText":{
      // //             "text":"找钢网测试号测试审核",
      // //             "action":"addFriend",
      // //             "actionData":"938197342"
      // //         },
      // //         "subText":{
      // //             "text":"8004444573",
      // //             "action":"addFriend",
      // //             "actionData":"938197342"
      // //         }
      // //     }
      // // };
      //   const data = {
      //     avatar: 'https://p.qpic.cn/qidian_pic/2852199203/20230104ac8d193276ae868e2bdeb635e39c30e9/0',
      //   };
      //   this.$refs.aio?.createQQInviteCard(data, { dir: 'b2c' });
      //   this.$refs.aio?.createAddQQFriendCard(data, { dir: 'b2c' });
      //   return;
      // }
      const btnType = item.type;
      switch (btnType) {
        case 'goodsListBtn':
          this.onGoodList();
          break;
        case 'orderListBtn':
          this.onOrderList();
          break;
        case 'capture':
          this.showCapture();
          break;
        case 'audio':
          this.audioCall();
          break;
        case 'video':
          this.videoCall();
          break;
        case 'sendBusinessCard':
          this.sendBusinessCard();
          break;
        default:
          // this.$Alert(`你点击了: ${item.type}`);
          break;
      }
    },

    showCapture() {
      this.$Alert({
        text: `<div class="scissorsPrompt">
        <div class="con" style="
          text-align: left;
          font-size: 12px;
        ">
            <div>${this.$t('common_screenshot_tip_QQ')}</div>
            <div>${this.$t('common_screenshot_tip_mac')}</div>
            <div>${this.$t('common_screenshot_tip_win')}</div>
        </div>
    </div>` });
    },

    // 自动完成条目选择
    onMsgAutoCompleteSelected(item) {
      // 发送选择项的文字
      this.$refs.aio?.sendTextMessage(item.question);
      // 清空输入框
      this.inputContent = '';
    },

    // 收到新消息
    onReceiveMsg(msg) {
      this.showBrowserNotification(msg);
    },

    handleTransferRobotMsg(msg) {
      this.$refs.cartoon && this.$refs.cartoon.handleTransferRobotMsg(msg);
    },

    handleVoiceRecodeStatus(status) {
      this.$refs.cartoon && this.$refs.cartoon.handleVoiceRecodeStatus(status);
      this.$refs.aiSpeaker && this.$refs.aiSpeaker.handleVoiceRecodeStatus(status);
    },

    handleKickedOut() {
      this.$refs.cartoon && this.$refs.cartoon.handleKickedOut();
      this.$refs.aiSpeaker && this.$refs.aiSpeaker.handleKickedOut();
    },

    /**
     * 显示浏览器通知
     */
    showBrowserNotification(data) {
      if (!document.hidden) {
        return;
      }

      const { IMSDK, MsgType } = this.$refs.aio.getSDKIntance();

      // 这里要过滤掉 时间和正在输入 这2种特殊消息
      if (!data.type || [MsgType.MSG_DATETIME, MsgType.MSG_TYPING].indexOf(data.type) > -1) {
        return;
      }

      let showTxt = '';

      if (data.type === IMSDK.TYPES.MSG_TEXT) {
        // 如果是文本消息，就显示内容
        showTxt = data.content;
        // 过滤html
        showTxt = showTxt.replace(/<[^>]+?>/g, '');
        // 如果是空文本，则跳过通知
        if (!showTxt) {
          return;
        }
      } else if (data.type === IMSDK.TYPES.MSG_IMAGE) {
        // 如果是图片消息，则提示收到图片
        showTxt = '收到一张图片';
      } else {
        // 默认情况提示 收到新消息
        showTxt = '收到一条新消息';
      }

      this.msgNotifyCount += 1;

      if (this.msgNotifyCount > 1) {
        showTxt = `您有${this.msgNotifyCount}条新消息`;
      }

      // 闪动标题栏
      this.twinkleHanlder.start();

      console.log('[Notification]', showTxt, new Date());

      // 调用浏览器Notification api 展示通知
      Notification.requestPermission(() => {
        const icon = './favicon.ico';
        const options = {
          tag: 'qd-webim-sdk-notification',
          requireInteraction: true,
          renotify: true,
          icon,
          badge: icon,
        };
        // 部分浏览器 new Notification 可能会报错，因此要处理一下
        let notification;
        try {
          notification = new Notification(showTxt, options);
        } catch (ex) {}
        if (!notification) {
          return;
        }
        this.notification = notification;
        // 点击时重置数值
        notification.onclick = () => {
          try {
            // 可能的iframe中嵌入的，优先执行top操作
            top.focus();
            window.focus();
          } catch (ex) {}

          this.clearNotification();
        };
      });
    },

    /**
     * 清理所有通知
     */
    clearNotification() {
      if (this.notification) {
        this.notification.close();
      }
      this.msgNotifyCount = 0;

      // 清理标题栏闪动
      this.twinkleHanlder.stop();
    },

    /**
     * 请求权限
     */
    requireNotifyPermission() {
      const handler = () => {
        window.Notification && Notification.requestPermission();
        document.body.removeEventListener('click', handler);
      };
      // 如果不是在iframe里才请求权限，否则浏览器会拒绝处理并可能报错。
      if ((window.parent === window)) {
      // 部分浏览器，如firefox，禁止在用户未操作时请求权限，因此在点击页面时才请求权限。
        document.body.addEventListener('click', handler);
      }

      // 页面刷新时清理通知
      window.addEventListener('unload', () => {
        this.clearNotification();
      });

      // 页面显示时清理通知
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.clearNotification();
        }
      });
    },

    /**
     * 闪动页面标题
     */
    twinkleDocTitle() {
      // 通过clearInterval清楚闪动
      const interval = 1000;
      const chantTitle = this.$t('common_new_message_text');

      return {
        start() {
          // 已经开启闪动了就不在触发。
          if (this.twinkleDocTitTimer) {
            return;
          }

          // 旧标题要存起来恢复用。
          const oldTitle = document.title;
          this.oldTitle = oldTitle;

          this.twinkleDocTitTimer =  setInterval(() => {
            document.title = (oldTitle === document.title) ? chantTitle : oldTitle;
          }, interval);
        },
        stop() {
          if (this.twinkleDocTitTimer) {
            clearInterval(this.twinkleDocTitTimer);
            this.twinkleDocTitTimer = null;
            document.title = this.oldTitle;
          }
        },
      };
    },

    // ------------------ iframe 操作 -------------------
    /**
     * wpa通过postMessage操作iframe内的webim页面
     */
    operateIframe(action, msgData) {
      console.log('operateIframe', action, msgData);

      // 上报IFARME操作
      this?.$refs?.aio?.customReport({
        method: 'operateIframe',
        action,
        msgData,
        referrer: document.referrer,
      });

      // 将wpa传递的参数存储到wpaDetail中
      if (!msgData.key) {
        msgData.key = msgData.wpaKey || this.wpaDetail.wpaKey;
      }
      msgData.wpaId && (msgData.fid = msgData.wpaId);
      // 原先写法有bug，这里修改一下。
      this.wpaDetail = Object.assign({}, this.wpaDetail, msgData);
      if (action === 'INIT') {
        myLocalStorage.setItem('tencentSig', this.wpaDetail.tencentSig);
        this.iframeIMStatus = 'close';
      } else if (action === 'OPEN') {
        this.iframeIMStatus = 'show';
        // 启动IM
        if (!this.hasIframeStartIM) {
          this.hasIframeStartIM = true;
          this.startIM();
        }
        this.notReadNumber = 0;
        this.onlineNotReadNum = 0;
      } else if (action === 'UPDATE_UNREAD') {
        if (this.iframeIMStatus === 'close') {
          this.onlineNotReadNum = msgData.number;
          if (this.unReadSum > 0) {
            wpaBridge.sendMsg({
              act: 'SHOW',
            });
          }
        }
      }
    },
    // 处理并存储wpa传递的参数到wpaDetail中
    handleWpaDetail(wpaDetail) {
      // TODO YULY roleData
      if (!wpaDetail.key) {
        wpaDetail.key = wpaDetail.wpaKey || this.wpaDetail;
      }
      Object.assign(this.wpaDetail, wpaDetail);
    },
    // wpa的iframe中的IM，点击顶部关闭按钮时的操作
    closeIframeIM() {
      if (!wpaBridge.inIframe() || wpaBridge.isHasDragged()) {
        return;
      }

      this.iframeIMStatus = 'close';
      wpaBridge.sendMsg({
        act: 'CLOSE',
        kfuin: this.wpaDetail.kfuin,
      });
    },
    // wpa的iframe中的IM，点击minibar的操作（仅PC）
    openIframeIM() {
      if (!wpaBridge.inIframe() || wpaBridge.isHasDragged()) {
        return;
      }

      this.iframeIMStatus = 'show';
      wpaBridge.sendMsg({
        act: 'OPEN',
        kfuin: this.wpaDetail.kfuin,
      });
    },
    // 获取im style config（合回saas重构新接口）
    fetchConfig() {
      const { kfuin, wpaId, key } = this.wpaDetail;
      const body = {
        kfuin,
        wpaId,
        key,
        fields: ['webimStyleConfig', 'tools', 'guidanceInfo'],
      };
      globalWin.kfuin = kfuin;
      fetchCommonInfo(body, ({ webimStyleConfig = {}, tools = {}, guidanceInfo = {} }) => {
        const { code: codeW, data: dataW } = webimStyleConfig;
        const { code: codeT, data: dataT } = tools;
        const { code: codeG, data: dataG } = guidanceInfo;

        if (0 === codeW) {
          this.styleConfig = dataW;
          const { openName, externalType, messageStyleConfig } = dataW;
          // 更新客服资料展示配置
          Object.assign(this.linkInfo, { ...this.linkInfo, openName, externalType });
          // 【已读回执】开关
          this.readStatusSwitch = !!messageStyleConfig?.readStatusSwitch;
          // 第二次调用，使用server返回的新配置和本地的theme进行merge和缓存。
          this.getCustomStyle(dataW);
        }
        if (0 === codeT) {
          Object.assign(this.showInfo, { ...this.showInfo, ...dataT });
        };
        if (0 === codeG) {
          console.log(3242424234324, dataG);
          // 注意赋值方式，否则可能数据无法响应处理
          Object.assign(this.guidanceInfo, dataG);
        }
        console.log('🥳 ~ fetchCommonInfo', this.styleConfig, this.showInfo, this.guidanceInfo);
      });

      const body2 = {
        kfuin,
        wpaId,
        key,
        fields: ['companyInfo'],
      };
      // 如果工号存在，并且是客服接待，则同时获取员工信息
      // 获取企业信息
      fetchCompanyInfo(body2, ({ companyInfo = {} }) => {
        const { code: codeC, data: dataC } = companyInfo;
        if (0 === codeC) {
          // 使用企业信息中 的名称和头像，设置B侧客服默认形象
          const { companyName: name, companyLogo: avatar } = dataC;
          this.companyInfo = dataC;
          // 更新名字
          if (name) {
            defaultExtuinInfo({ name });
          }
          // 更新头像
          if (avatar) {
            defaultExtuinInfo({ avatar });
          }
        }
      });
    },
    // 获取电商 config（合回saas重构新接口）
    fetchEcQuickMenuConfig() {
      const { kfuin, wpaId, key } = this.wpaDetail;
      const body = {
        kfuin,
        wpaId,
        key,
        visitorId: this.wpaDetail.visitorid,
        fields: ['ecQuickMenu'],
      };
      fetchCommonInfo(body, ({ ecQuickMenu = {} }) => {
        const { code: codeE, data: dataE } = ecQuickMenu;
        if (0 === codeE) {
          // 电商 商品 订单 按钮权限
          this.showInfo.isShowGoods = dataE.goodsShow;
          this.showInfo.isShowOrder = dataE.orderShow;
          // 电商整个配置
          Object.assign(this.ecQuickMenu, dataE);
        }

        console.log('🥳 ~ fetchEcQuickMenuConfig', this.ecQuickMenu);
      });
    },
    // 获取员工信息
    fetchEmployeeInfo(kfext) {
      const { kfuin } = this.wpaDetail;
      const body = {
        kfext,
        kfuin,
        fields: ['employeeInfo'],
      };
      fetchCompanyInfo(body, ({ employeeInfo = {} }) => {
        const { code: codeE, data: dataE } = employeeInfo;
        if (0 === codeE) {
          // 员工信息
          this.employeeInfo = dataE;
        }
      });
    },

    /**
     * 监测当前接待是否使用v3版webim，来判定是否进行跳转到【老webim】。同时返回通用鉴权跳转url
     * {int} anonymous 是否匿名访问
     */
    async checkIfWebimV3(anonymous = 0) {
      const { kfuin, wpaId } = this.wpaDetail;
      // 仅检查链接型的跳转。图标、DOM型由 wpa侧保证。
      if (this.inIframe || !kfuin || !wpaId) {
        return;
      }

      const url = `${CHECK_IF_WEBIM_V3}?kfuin=${kfuin}&channelType=4&wpaId=${wpaId}&anonymous=${anonymous}`;
      try {
        const res = await this.$ajax.get(url, '', { timeout: 6 * 1000 });
        const rs = res.data;
        if (rs.code === 0) {
          const { uint32_channel_version: channeV, string_auth_url: redirectUrl } = rs.data;
          if (channeV === 0) {
          // 老webim，此时应该进行跳转

            // 如果要上报的话，需要延迟跳转
            setTimeout(() => {
            // $1 为 set值，  $2 为PC或H5页面
              let oldUrl = location.href.replace(/\/qidian\/chatv3(-\w+)?\/(pc|h5)\.html/i, '/2/chat$1/$2/index.html');
              if (oldUrl.indexOf('/2/chat') === -1) {
              // 防止替换错误，死循环
                return;
              }
              oldUrl += '&im_jump_from=v3';
              location.replace(oldUrl);
            }, 0);
          }

          return redirectUrl;
        }
      } catch (ex) {}

      return '';
    },

    /**
     * AIO报错处理
     * @param {object<{code, message}>} error 报错信息
     */
    handleAioError(error) {
      // aid/d2错误。
      if (error.type === 'd2Expire' || error.type === 'd2Error') {
        // 注意此方法定义在MixinLogin.js中
        this.hanldErrorForD2(error);
      }
    },

    /**
     * 处理音视频通话事件
     */
    handleNotifyRtc(data) {
      console.log(data);
    },
    // 按钮栏商品按钮点击
    onGoodList() {
      this.goodsListShow = !this.goodsListShow;
    },
    // 按钮栏订单按钮点击
    onOrderList() {
      this.orderListShow = !this.orderListShow;
    },
    // 处理 aio 中的SessionStart
    handleSessionStart() {
      this.sessionStart = true;

      // 已实名才去获取电商配置
      if (this.authConf.authType === 'commonAuth') {
        // 获取电商配置
        this.fetchEcQuickMenuConfig();
      }
      // 处理广交会进线之后的逻辑，自动发送名片/发送XML结构化消息
      this.handleGJHEntry();
    },
    /**
     * 广交会进线之后的逻辑
     */
    async handleGJHEntry() {
      try {
        // 自动发送名片逻辑
        if (this.isSendBizCardInstant) {
          setTimeout(() => {
            this.sendBusinessCard();
          }, 300);
        }
        let msginfo = this.storeGJHMsgInfo(true);
        if (msginfo) {
          if (typeof msginfo !== 'object') {
            msginfo = JSON.parse(msginfo);
          }
          const authType = this?.authConf?.authType;
          const xmlMsg = await getInitXmlMsg(msginfo, authType);
          globalWin.sendQDXMLMessage({
            qdxml: {
              content: xmlMsg,
            },
          });
        }
      } catch (e) {
        console.error('JSON解析失败', e);
      }
    },
    // 广交会发送名片
    sendBusinessCard() {
      const { kfuin } = this.wpaDetail;
      const authType = this?.authConf?.authType;
      const kfext = this?.reception?.extuin;
      if (!kfext) {
        this.$Toast('客服不在线，无法发送名片');
        return;
      }
      const authConfig = AUTH_TYPE[authType];
      const { apiDomain = 'it-blinkapi.cantonfair.org.cn' } = authConfig;
      const params = {
        kfuin,
        cAid: Number(this.$refs.aio?.to?.user_id),
        kfext: this?.reception?.extuin,
        apiDomain,
        lang: this.$i18n.locale,
      };
      const { appid, aid, d2 } =  globalWin.auth;
      const headers = {
        'X-Appid': appid,
        'X-Aid': aid,
        'X-D2': d2,
        'X-Tenant-Id': globalWin.kfuin,
      };
      this.$ajax.post(`${SEND_BUSINESS_CARD}`, params, { headers })
        .then((res) => {
          const { data } = res;
          const { r, cardInfo } = data;
          if (+r === 0) {
            globalWin.sendQDXMLMessage({
              qdxml: {
                content: cardInfo,
              },
            });
          }
        })
        .catch((e) => {
          console.log('获取名片信息失败', e);
          this.$Toast('失败');
        });
    },
    // 拉取机器人配置信息
    fetchRobotConfig() {
      const { kfuin, wpaId, key } = this.wpaDetail;
      const params = {
        kfuin,
        wpaId,
        key,
        fields: ['robotConfig'],
        robotId: this?.reception?.robotId,
      };
      fetchCommonInfo(params, (res) => {
        const { robotConfig = {} } = res;
        const { code, data = {} } = robotConfig;
        if (+code === 0) {
          // 是否开放机器人联想词功能
          this.canRobotAutoComplete = !!data.canAutocomplete;
        }
      });
    },
  },
};
